import React, { useState } from "react";
import axios from "axios";

const useHashTag = ({
    onFinish = ({ axiosMode, status, values }) => {},
    onBefore = ({ axiosMode, status }) => {},
}) => {
    const [data, setData] = useState([]);
    let mainApi = `/media_classification_storage/api/classify/media/hashtag`;
    const getHashTagData = (params) => {
        onBefore({
            axiosMode: "get",
        });
        return axios
            .get(mainApi, {
                params: params,
            })
            .then((response) => {
                let data = response.data;
                setData(data?.data);
                if (data) {
                    onFinish({
                        axiosMode: "get",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "get",
                        status: "error",
                    });
                }

                return {
                    ...data,
                };
            });
    };
    const postHashTagData = (data) => {
        onBefore({
            axiosMode: "post",
        });
        axios
            .post(mainApi, data)
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "fail") {
                    onFinish({
                        axiosMode: "post",
                        status: "error",
                    });
                } else {
                    onFinish({
                        axiosMode: "post",
                        status: "success",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "post",
                    status: "error",
                });
            });
    };
    const patchHashTagData = (data) => {
        onBefore({
            axiosMode: "patch",
        });
        axios
            .patch(
                mainApi,

                data
            )
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "fail") {
                    onFinish({
                        axiosMode: "patch",
                        status: "error",
                    });
                } else {
                    onFinish({
                        axiosMode: "patch",
                        status: "success",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "patch",
                    status: "error",
                });
            });
    };
    const deleteHashTagData = (data) => {
        onBefore({
            axiosMode: "delete",
        });
        axios
            .delete(mainApi, {
                data,
            })
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "fail") {
                    onFinish({
                        axiosMode: "delete",
                        status: "error",
                    });
                } else {
                    onFinish({
                        axiosMode: "delete",
                        status: "success",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "delete",
                    status: "error",
                });
            });
    };
    return {
        HashTagData: data,
        getHashTagData,
        postHashTagData,
        patchHashTagData,
        deleteHashTagData,
    };
};
export { useHashTag };
